import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-user-avatar',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div
      [title]="name"
      [ngClass]="sizeClasses"
      class="relative inline-flex items-center justify-center rounded-full bg-slate-800 text-white font-bold overflow-hidden border border-slate-700/50 shadow-2xs shrink-0 select-none">
      @if (src) {
        <img [src]="src" [alt]="name" class="w-full h-full object-cover" />
      } @else {
        <span class="text-xs uppercase font-extrabold tracking-wider text-slate-300">
          {{ getInitials(name) }}
        </span>
      }
    </div>
  `,
})
export class UserAvatarComponent {
  @Input() name = 'User';
  @Input() src?: string;
  @Input() size: 'xs' | 'sm' | 'md' | 'lg' = 'sm';

  get sizeClasses(): string {
    switch (this.size) {
      case 'xs':
        return 'w-5 h-5 text-[9px]';
      case 'sm':
        return 'w-7 h-7 text-xs';
      case 'md':
        return 'w-9 h-9 text-sm';
      case 'lg':
        return 'w-12 h-12 text-base';
      default:
        return 'w-7 h-7 text-xs';
    }
  }

  getInitials(name: string): string {
    if (!name) return 'U';
    const parts = name.trim().split(' ');
    if (parts.length >= 2) {
      return (parts[0][0] + parts[1][0]).toUpperCase();
    }
    return parts[0].substring(0, 2).toUpperCase();
  }
}
